import { spUrl } from "utils";
import { request } from "utils/proxy";
import { API_GROUP_ROLES } from "globals/constants";


export const groupRoles = {
	get: (options) => request(spUrl(API_GROUP_ROLES), options),
};
